/**
 * Room codes (2026-10-06, the user's request): every study room is entered with a three
 * character code, so groups reviewing the same study meet in separate rooms. The same code
 * is the same room; a new code is a new, empty room. On the wire a study room is
 * `<study>.<code>`, for example `ONC-2041.K7P`.
 */

export const ROOM_CODE_LENGTH = 3;

/** Generated codes leave out the look-alikes (0 and O, 1 and I); typed codes may use any. */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/** Upper-cases a typed code and keeps letters and digits; undefined unless exactly three. */
export function normaliseRoomCode(raw: string): string | undefined {
  const code = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
  return code.length === ROOM_CODE_LENGTH ? code : undefined;
}

export function roomKey(study: string, code: string): string {
  return `${study}.${code}`;
}

/** The study and code of a study room's key; undefined for the lobby or a malformed key. */
export function parseRoomKey(key: string): { study: string; code: string } | undefined {
  const dot = key.lastIndexOf('.');
  if (dot <= 0) return undefined;
  const study = key.slice(0, dot);
  const code = key.slice(dot + 1);
  return /^[A-Z0-9]{3}$/.test(code) ? { study, code } : undefined;
}

export function randomRoomCode(random: () => number = Math.random): string {
  let out = '';
  for (let i = 0; i < ROOM_CODE_LENGTH; i++)
    out += ROOM_CODE_ALPHABET[Math.floor(random() * ROOM_CODE_ALPHABET.length)];
  return out;
}
